<template>
	<div class="notifications-panel">
		<header class="notifications-header">
			<h3>{{ $t('nav.notifications') }}</h3>
			<span>{{ actionCount }}</span>
		</header>

		<div class="notifications-list" v-if="actionItems && actionCount">
			<deliverables
				v-if="features.projectsEnabled"
				:deliverables="actionItems.assignedTasks || []"
				task-mode
				@refresh="getActionItems"
			></deliverables>
			<tickets
				v-if="features.ticketsEnabled"
				:tickets="actionItems.openTickets || []"
			></tickets>
			<deliverables
				v-if="features.projectsEnabled"
				:deliverables="actionItems.deliverables || []"
				@refresh="getActionItems"
			></deliverables>
			<invoices
				v-if="features.invoicesEnabled"
				:invoices="actionItems.invoices || []"
				@refresh="getActionItems"
			></invoices>
			<forms
				v-if="features.formsEnabled"
				:forms="actionItems.forms || []"
				@refresh="getActionItems"
			></forms>
			<proposals
				v-if="features.proposalsEnabled"
				:proposals="actionItems.proposals || []"
				:agreements="actionItems.agreements || []"
				@refresh="getActionItems"
			></proposals>
			<meetings
				v-if="features.meetingsEnabled"
				:meetings="actionItems.meetings || []"
				@refresh="getActionItems"
			></meetings>
			<subscription-requests
				v-if="features.invoicesEnabled"
				:subscription-requests="actionItems.subscriptionRequests || []"
				@refresh="getActionItems"
			></subscription-requests>
		</div>

		<div class="notifications-empty" v-else-if="actionItems">
			<span><portal-icon name="check" :size="22"></portal-icon></span>
			<strong>0 {{ $t('nav.notifications') }}</strong>
		</div>
	</div>
</template>

<script>
	import SubscriptionRequests from '@/modules/welcome/actionItems/SubscriptionRequests';
	import Deliverables from '@/modules/welcome/actionItems/Deliverables';
	import Invoices from '@/modules/welcome/actionItems/Invoices';
	import Forms from '@/modules/welcome/actionItems/Forms';
	import Meetings from '@/modules/welcome/actionItems/Meetings';
	import Proposals from '@/modules/welcome/actionItems/Proposals';
	import DashboardService from '@/modules/welcome/DashboardService';
	import Tickets from '@/modules/welcome/actionItems/Tickets';

	export default {
		name: 'Notifications',

		components: { SubscriptionRequests, Deliverables, Invoices, Meetings, Proposals, Forms, Tickets },

		data() {
			return {
				actionItems: null,
				dashboardService: new DashboardService(),
			};
		},

		mounted() {
			this.getActionItems();
		},

		methods: {
			getActionItems() {
				this.dashboardService.getActionItems().then((response) => {
					this.actionItems = response.data;
				});
			},
		},

		watch: {
			actionCount: {
				immediate: true,
				handler(value) {
					this.$store.state.actionCount = value;
				},
			},
		},

		computed: {
			features() {
				return this.$store.getters.getFeatures || {};
			},

			actionCount() {
				if (!this.actionItems) return 0;
				return ['assignedTasks', 'openTickets', 'deliverables', 'invoices', 'proposals', 'meetings', 'subscriptionRequests', 'agreements', 'forms']
					.map((key) => (this.actionItems[key] || []).length)
					.reduce((total, count) => total + count, 0);
			},
		},
	};
</script>

<style scoped lang="scss">
	.notifications-panel {
		min-height: 100%;
		padding: 18px;
		background: var(--portal-canvas);
		color: var(--portal-text);
	}

	.notifications-header {
		display: flex;
		align-items: center;
		justify-content: space-between;
		gap: 12px;
		margin-bottom: 14px;
	}

	.notifications-header h3 {
		margin: 0;
		color: var(--portal-text);
		font-size: 18px;
		font-weight: 600;
	}

	.notifications-header span {
		min-width: 26px;
		height: 26px;
		display: grid;
		place-items: center;
		padding: 0 7px;
		border-radius: 99px;
		background: var(--v-gray_20-base);
		color: var(--portal-muted);
		font-size: 12px;
		font-weight: 600;
	}

	.notifications-list {
		display: grid;
		gap: 12px;
	}

	.notifications-empty {
		min-height: 160px;
		display: grid;
		place-items: center;
		align-content: center;
		gap: 10px;
		color: var(--portal-muted);
		text-align: center;
	}

	.notifications-empty span {
		width: 40px;
		height: 40px;
		display: grid;
		place-items: center;
		border-radius: 50%;
		background: var(--v-blue_5-base);
		color: var(--v-primary-base);
	}
</style>
